/**
 * Module-level auth-token singleton (mirrors frontend/src/lib/auth/
 * tokenStore.ts) — lets the API layer read the current token without
 * importing React context.
 */
let globalTokenGetter: (() => string | null) | null = null;

export const setGlobalTokenGetter = (getter: () => string | null): void => {
  globalTokenGetter = getter;
};

export const getGlobalAuthToken = (): string | null =>
  globalTokenGetter ? globalTokenGetter() : null;
